import { render } from "./invoiceItemTwo.vue?vue&type=template&id=65d08d55"
import script from "./invoiceItemTwo.vue?vue&type=script&lang=js"
export * from "./invoiceItemTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__